export const PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE = 'profile-components-common';
